import React from "react";

interface Props {
  label?: string
}

const BrandFormField = (props: React.PropsWithChildren<Props>) => {
  return <div className="margin-bottom-small flex-column gap-mini">
    {(props.label) && <div className="text-sublabel">{props.label}</div>}
    <div>
      {props.children}
    </div>
  </div>;
};

export default BrandFormField;